import { jsx as _jsx } from "react/jsx-runtime";
import DocumentPage from "./DocumentPage";
import ErrorPage from "../../templates/ErrorPage";
import { Loader } from "./subcomponents";
var DocumentContent = function (_a) {
    var cachedBlob = _a.cachedBlob, isLoading = _a.isLoading, isError = _a.isError;
    if (cachedBlob && !isLoading) {
        return _jsx(DocumentPage, { filePath: cachedBlob });
    }
    if (isError) {
        return _jsx(ErrorPage, {});
    }
    return _jsx(Loader, {});
};
export default DocumentContent;
